<script setup lang="ts">
import { getBasicUnauthorizedResponse } from 'pejer/src/helpers'
import { usePejerBase } from 'pejer/src/stores/pejerData'
import { unref } from 'vue'
import { DataStateLoose } from '../../types/types'
import DataStateError from './DataStateError.vue'
import DataStateLoading from './DataStateLoading.vue'

defineProps<
  {
    showSlot?: boolean
  } & DataStateLoose
>()

const pejer = usePejerBase()
</script>
<template>
  <DataStateError v-if="url && !pejer.isPermitted(url)" :error="getBasicUnauthorizedResponse()" />
  <template v-else-if="unref(isLoading) == true">
    <slot name="loading">
      <DataStateLoading />
    </slot>
  </template>
  <template v-else-if="unref(isError) == true">
    <slot name="error" :error="unref(error)">
      <DataStateError :error="unref(error)" />
    </slot>
  </template>
  <slot v-else-if="showSlot"></slot>
  <slot v-else></slot>
</template>
